import {Sprite} from 'pixi.js';
import {TextFactory} from '../../../../../../../factories/TextFactory';
import {Pivot} from '../../../../../../../utils/Pivot';
import {TextInput} from 'pixi-textinput-v5';
import {NameInputEvents} from './name_input/NameInputEvents';
import MessageHelper from '../../../../../../../../../../helpers/MessageHelper';

export class NameInput extends Sprite
{
    valueText: TextInput;
    private beginInputText: string = '';
    private textInput:HTMLTextAreaElement;
    private onInputBindThis:(e:Event)=>void;


    constructor(private playerId: string) {
        super();

        this.valueText = new TextInput({
            multiline: false,
            box: {
                default: {fill: 0x3F4246, rounded: 8}
            }, input: {
                multiline: false,
                fontSize: 30 + 'px',
                fontFamily: TextFactory.DEFAULT_FONT,
                padding: 5 + 'px',
                width: 100 + 'px',
                height: 40 + 'px',
                color: 0xffffff,
                textAlign: 'left',
                rows: 1
            }
        });

        this.addChild(this.valueText);

        this.textInput = this.valueText._dom_input as HTMLTextAreaElement;
        this.textInput.style.color = '#fff';
        this.onInputBindThis = this.onInput.bind(this);
        this.textInput.addEventListener('input', this.onInputBindThis);

        this.valueText.on('focus', this.onFocus, this);
        this.valueText.on('blur', this.onBlur, this);

    }

    private onInput():void{
        if (this.textInput.value.length > 6) {
            this.textInput.value = this.textInput.value.substr(0, 6);
        }
    }

    set playerName(val: string) {
        // @ts-ignore
        this.valueText.text = val;
        Pivot.centerPivot(this.valueText, false);
    }

    destroy(): void {
        this.textInput.removeEventListener('input', this.onInputBindThis);
        delete this.onInputBindThis;
        this.valueText.off('focus', this.onFocus, this);
        this.valueText.off('blur', this.onBlur, this);
        super.destroy({children: true});
    }

    private onFocus(): void {
        // @ts-ignore
        this.beginInputText = this.valueText.text;
        dispatchEvent(new MessageEvent(NameInputEvents.LOCK_BY_INPUTING));

    }

    private onBlur(): void {
        dispatchEvent(new MessageEvent(NameInputEvents.UNLOCK_BY_INPUTING));
        // @ts-ignore
        if (this.beginInputText == this.valueText.text) {
            return;
        }
        const data = {
            playerId: this.playerId,
            name: this.valueText.text
        };
        MessageHelper.changePlayerNameMessage(data);
    }
}
